var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHighlighter(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.50134 9.14852L8.60945 10.0379C8.07378 10.5736 7.8917 11.3865 7.79936 12.1384C7.71543 12.8218 7.42754 13.7385 6.63549 14.7522C6.29546 15.1874 6.28729 15.8168 6.67782 16.2073L8.79301 18.3225M6.67782 16.2073L2.50012 20.5002H6.50012L8.79301 18.3225M8.79301 18.3225C9.18354 18.713 9.8129 18.7049 10.2481 18.3648C11.2618 17.5728 12.1785 17.2849 12.8619 17.201C13.6138 17.1086 14.4267 16.9265 14.9624 16.3909L15.8518 15.499M13.7354 3.50024L9.50134 7.73431C9.11082 8.12483 9.11082 8.758 9.50134 9.14852L15.8518 15.499M15.8518 15.499C16.2423 15.8895 16.8755 15.8895 17.266 15.499L21.5001 11.2649",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHighlighter);
export default __webpack_public_path__ + "static/media/highlighter.ebe2212c0632b22c789714a5cd53710c.svg";
export { ForwardRef as ReactComponent };